import { motion } from "framer-motion";
import { useBuyGuide } from "../hooks/useBuyGuide";

export default function FeaturedProduct() {
  const { loading, buyGuide: handleBuy } = useBuyGuide();

  return (
    <section
      id="product"
      data-testid="product-section"
      className="py-24 md:py-40 px-6 md:px-12 lg:px-20"
      style={{ background: "#F2EBE5" }}
    >
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
          className="md:col-span-6 order-2 md:order-1"
        >
          <span className="overline" data-testid="product-overline">Featured · The Guide</span>
          <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl mt-6 leading-[1.05]">
            The <em>Soft Life</em> AI Guide.
          </h2>
          <div className="gold-hair mt-8" />
          <p className="mt-8 max-w-lg text-[15px] md:text-base leading-relaxed text-[#5C5A56]">
            A 25-page editorial guidebook of curated prompt collections, elegant workflows, and quiet automations —
            everything you need to hand off the boring parts of life to AI, and keep the fabulous parts for yourself.
          </p>

          <ul className="mt-8 space-y-3 text-[15px] text-[#1A1A1A]">
            {[
              "6 curated prompt collections for work, home, and content creation",
              "Ready-to-use workflows for content, admin, and planning",
              "A daily AI ritual designed for softness, not hustle",
            ].map((f, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="mt-2 inline-block w-1.5 h-1.5" style={{ background: "#C28C55" }} />
                <span>{f}</span>
              </li>
            ))}
          </ul>

          <div className="mt-12 flex items-baseline gap-4">
            <span className="font-serif text-6xl md:text-7xl font-light" data-testid="product-price">$27</span>
            <span className="overline" style={{ color: "#5C5A56" }}>USD · Instant Access</span>
          </div>

          <button
            onClick={handleBuy}
            disabled={loading}
            className="btn-primary mt-8"
            data-testid="product-buy-button"
          >
            {loading ? "Opening Checkout…" : "Buy the Guide"}
            <span aria-hidden>→</span>
          </button>

          <p className="mt-6 text-xs tracking-widest uppercase text-[#5C5A56]">
            Secure payment via Stripe
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
          className="md:col-span-6 order-1 md:order-2 relative"
        >
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1618434958571-459c9c972ae8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxjaGFtcGFnbmUlMjBzaWxrJTIwdGV4dHVyZXxlbnwwfHx8fDE3ODM4ODc2NDB8MA&ixlib=rb-4.1.0&q=85"
              alt="Champagne silk still-life"
              className="w-full h-[70vh] object-cover"
              loading="lazy"
              data-testid="product-image"
            />
            {/* Sharp editorial title card rendered as HTML/CSS text over a soft luxury still-life */}
            <div
              className="absolute inset-x-6 top-1/2 -translate-y-1/2 md:inset-x-10"
              data-testid="product-title-overlay"
            >
              <div
                className="mx-auto max-w-[70%] text-center px-8 py-10 md:py-14"
                style={{
                  background: "#FAF9F6",
                  border: "1px solid rgba(212, 175, 55, 0.45)",
                  boxShadow: "0 24px 70px rgba(26, 26, 26, 0.12)",
                }}
              >
                <span className="overline block" data-testid="product-overlay-overline">Volume One</span>
                <h3
                  className="font-serif font-light italic leading-[1.02] mt-4 text-3xl md:text-4xl lg:text-5xl"
                  style={{ WebkitFontSmoothing: "antialiased", textRendering: "geometricPrecision" }}
                >
                  The Soft Life<br />
                  <span className="not-italic tracking-tight">AI Guide</span>
                </h3>
                <div className="gold-hair mt-6" />
                <p className="mt-5 text-[11px] tracking-[0.3em] uppercase text-[#5C5A56]">
                  By Findaura Ventures
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
